module.exports = {
  parent: 'parentElement',
  touches: 'targetTouches',
  y: 'screenY'
};